import axios from 'axios';

//const BASE_URL = 'http://localhost:8000/'
// const BASE_URL = 'http://20.206.201.63:8000/'
// const BASE_URL = 'https://homolog-orchestrator.postei.ai/'

// const BASE_URL = 'http://orchestrator:8000/'

const BASE_URL = import.meta.env.VITE_ORCHESTRATOR_URL
const isMock = String(import.meta.env.VITE_IS_MOCK).toLowerCase() === 'true' ? true : false


const OrchestratorApi = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

// Add interceptor to include token dynamically
OrchestratorApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token').replaceAll('"', '')
  if (token && token !== 'null' && token !== 'undefined') {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const postVoiceCampaign = async (body) => {

  return await OrchestratorApi
    .post('api/v1/voice-campaign/', body)
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postVoiceCampaign', error.response.data)
      return error
    })
}

export const postGenerateImages = async (body) => {

  return await OrchestratorApi
    .post('api/v1/generate-images/', body)
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postGenerateImages', error.response.data)
      return error
    })
}

export const postGenerateArt = async (body) => {

  return await OrchestratorApi
    .post('api/v1/generate-art/', body)
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postGenerateArt', error.response.data)
      return error
    })
}

export const postGenerateArtTemplate = async (body, moreConfig) => {

  const config = {
    ...moreConfig,
  }
  return await OrchestratorApi
    .post('api/v1/generate-art-templates/', { ...body, isMock }, { ...config })
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postGenerateArtTemplate', error.response.data)
      return error
    })
}

export const postGenerateArtWithReference = async (body, moreConfig) => {
  const config = {
    ...moreConfig,
  }
  return await OrchestratorApi
    .post('api/v1/generate-art-with-reference/', { ...body }, { ...config })
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postGenerateArtWithReference', error.response.data)
      return error
    })
}

export const postEditArtWithReference = async (body, moreConfig) => {
  const config = {
    ...moreConfig,
  }
  return await OrchestratorApi
    .post('api/v1/edit-art-with-reference/', { ...body }, { ...config })
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postEditArtWithReference', error.response.data)
      return error
    })
}

export const postRegenerateArtWithReference = async (body, moreConfig) => {
  const config = {
    ...moreConfig,
  }
  return await OrchestratorApi
    .post('api/v1/regenerate-art-with-reference/', { ...body }, { ...config })
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postRegenerateArtWithReference', error.response.data)
      return { data: error }
    })
}
export const postGenerateArtAi = async (body, moreConfig) => {

  const config = {
    ...moreConfig,
  }
  return await OrchestratorApi
    .post('api/v1/generate-art/', body, { ...config })
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postGenerateArtAi', error.response.data)
      return error
    })
}

export const postGenerateArtEditTemplate = async (body) => {

  return await OrchestratorApi
    .post('api/v1/edit-art-templates/', body)
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postGenerateArtEditTemplate', error.response.data)
      return error
    })
}
export const postGenerateArtEditPrompt = async (
  body
) => {


  return await OrchestratorApi
    .post('api/v1/edit-art/', { ...body, isMock })
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postGenerateArtEditTemplate', error.response.data)
      return error
    })
}

export const postHeadline = async (body) => {

  return await OrchestratorApi
    .post('api/v1/headline/', body)
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postHeadline', error.response.data)
      return error
    })
}

export const postRemoveBackground = async (formData) => {

  return await OrchestratorApi
    .post('api/v1/remove-background/', formData)
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postRemoveBackground', error.response.data)
      return error
    })
}

export const postAddLogoToImage = async (formData) => {

  return await OrchestratorApi
    .post('api/v1/add-logo-to-images/', formData)
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postAddLogoToImage', error.response.data)
      return error
    })
}

export const postGenerateMenu = async (body) => {

  return await OrchestratorApi
    .post('api/v1/generate-menu/', body)
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postGenerateMenu', error.response.data)
      return { data: error }
    })
}

export const postPromptGPT = async (body, moreConfig) => {

  const config = {
    ...(moreConfig ? moreConfig : {}),
  }

  return await OrchestratorApi
    .post('api/v1/chat/', body, { ...config })
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error?.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postGenerateArtTemplate', error.response.data)
      return error
    })
}

export const postGenerateNewColorPallet = async (body) => {

  return await OrchestratorApi
    .post('api/v1/colors/new-pallet', body)
    .then((response) => {
      return { data: response }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postGenerateArtTemplate', error.response.data)
      return error
    })
}